import { qs } from "@fluorescent/dom";
import debounce from "@/utils/debounce";

export default function PredictiveSearch(
  resultsDropdownEl,
  resultsContainerEl,
  resultsViewAllButtonTextEl
) {
  const settings = qs("[data-search-settings]", document);
  const { limit } = JSON.parse(settings.innerHTML);
  const responseCache = {};

  function _renderSearchResultsFromResponse(text, term) {
    const resultsMarkup = new DOMParser().parseFromString(text, "text/html");
    const resultsWrapper = resultsMarkup.querySelector(".quick-search-results");

    const resultsCount = resultsWrapper.getAttribute("data-results-count");

    resultsDropdownEl.setAttribute("data-results-count", resultsCount);
    resultsContainerEl.innerHTML = resultsWrapper.innerHTML;

    resultsDropdownEl.setAttribute("data-loading", false);

    if (term) {
      resultsViewAllButtonTextEl.innerText = resultsViewAllButtonTextEl
        .getAttribute("data-label-with-query")
        .replace("{{ query }}", term);
    } else {
      resultsViewAllButtonTextEl.innerText =
        resultsViewAllButtonTextEl.getAttribute("data-label");
    }
  }

  function _fetchResults(url, term) {
    if (responseCache[url]) {
      return _renderSearchResultsFromResponse(responseCache[url], term);
    }

    fetch(url)
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then(responseText => {
        // It seems like we should just forego this caching layer and lean on browser
        // caching however Shopify's responses dictate no-cache behavhiour so we can't
        responseCache[url] = responseText;
        _renderSearchResultsFromResponse(responseText, term);
      })
      .catch(error => {
        throw error;
      });
  }

  // Search results from standard search page
  function getSearchResults(settings) {
    const query = settings.productType
      ? `product_type:${settings.productType} AND ${settings.searchTerm}`
      : settings.searchTerm;

    const endpoint = window.theme.routes.predictive_search_url;

    const params = new URLSearchParams();

    params.set("section_id", "quick-search-results");
    params.set("q", query);
    params.set("resources[limit_scope]", "each");
    params.set("resources[limit]", limit);

    const url = `${endpoint}?${params.toString()}`;

    resultsContainerEl.innerHTML = "";
    resultsDropdownEl.setAttribute("data-loading", true);

    // Small debounce to not search on every keydown
    debounce(() => _fetchResults(url, settings.searchTerm), 300)();
  }

  return {
    getSearchResults,
  };
}
